import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-080041f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleAndDescription = _resolveComponent("TitleAndDescription")!
  const _component_ButtonItem = _resolveComponent("ButtonItem")!

  return (_openBlock(), _createElementBlock("div", {
    class: "image-item",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("img", {
      src: _ctx.itemImg.linkImage,
      alt: "image",
      class: "image-item__img"
    }, null, 8, _hoisted_1),
    (_ctx.itemImg.title)
      ? (_openBlock(), _createBlock(_component_TitleAndDescription, {
          key: 0,
          title: _ctx.itemImg.title,
          description: _ctx.itemImg.description
        }, null, 8, ["title", "description"]))
      : _createCommentVNode("", true),
    (_ctx.itemImg.titleButton)
      ? (_openBlock(), _createBlock(_component_ButtonItem, {
          key: 1,
          title: _ctx.itemImg.titleButton,
          iconRsc: _ctx.itemImg.iconRsc,
          isShowLineButtom: _ctx.itemImg.isShowLineButtom
        }, null, 8, ["title", "iconRsc", "isShowLineButtom"]))
      : _createCommentVNode("", true)
  ]))
}